import React from 'react';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { DashboardPreview } from '../components/DashboardPreview';
import { CheckInPreview } from '../components/CheckInPreview';
import { AnalyticsPreview } from '../components/AnalyticsPreview';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { Activity } from 'lucide-react';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-230">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-100" data-id="element-231">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-232">
          <div className="flex items-center justify-between h-20" data-id="element-233">
            <div className="flex items-center gap-2" data-id="element-234">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#FF6B35] to-[#FF8E53] flex items-center justify-center text-white shadow-lg shadow-orange-500/20" data-id="element-235">
                <Activity className="w-5 h-5" data-id="element-236" />
              </div>
              <span className="text-xl font-bold tracking-tight" data-id="element-237">
                ActiveTally
              </span>
            </div>
          </div>
        </div>
      </nav>

      <main data-id="element-238">
        <Hero data-id="element-239" />
        <Features data-id="element-240" /> <DashboardPreview data-id="element-241" />
        <CheckInPreview data-id="element-242" />
        <AnalyticsPreview data-id="element-243" />
        <ContactForm data-id="element-244" />
        {/* CTA Section */}
        <section className="py-24 bg-gradient-to-br from-[#0A7E8C] to-[#086A76] text-white overflow-hidden relative" data-id="element-245">
          <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-246" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-white/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-247" />

          <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-248">
            <h2 className="text-3xl sm:text-5xl font-bold mb-6" data-id="element-249">
              Ready to modernize your program?
            </h2>{' '}
            <p className="text-xl text-teal-100 mb-10 max-w-2xl mx-auto" data-id="element-250">
              Join leading fitness facilities who are saving time and reducing
              fraud with ActiveTally.
            </p>
            <div className="flex justify-center" data-id="element-251">
              <Button size="lg" className="bg-white text-[#0A7E8C] hover:bg-teal-50 hover:shadow-xl hover:shadow-black/10" data-id="element-252">
                Contact Us
              </Button>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-253" />
    </div>;
}